//These functions will push events to chatbot-loader.js (iFrame loaded in websites)

//EVENTS
const APP_LOADED = 'APP_LOADED'
export const OPEN_CHATBOT = 'OPEN_CHATBOT'
export const CLOSE_CHATBOT = 'CLOSE_CHATBOT'
const SHOW_CHATBOT = 'SHOW_CHATBOT'
const HIDE_CHATBOT = 'HIDE_CHATBOT'
const SHOW_POPUP_MESSAGE = 'SHOW_POPUP_MESSAGE'
const LOAD_FLOW = 'LOAD_FLOW'
export const SET_CHATBOT_ID = 'SET_CHATBOT_ID';
const POSITION_LEFT = 'POSITION_LEFT';

export const notifyAppLoaded = () => {
    // eslint-disable-next-line no-unused-expressions
    window.top?.postMessage({type: APP_LOADED}, '*');
}

export const notifyShowChatbot = () => {
    // eslint-disable-next-line no-unused-expressions
    window.top?.postMessage({type: SHOW_CHATBOT}, '*');
};

export const notifyShowPopupMessage = (message,size) => {
    // eslint-disable-next-line no-unused-expressions
    window.top?.postMessage({type: SHOW_POPUP_MESSAGE, payload: {message},size:size}, '*');
};

export const notifyHideChatbot = () => {
    // eslint-disable-next-line no-unused-expressions
    window.top?.postMessage({type: HIDE_CHATBOT}, '*');
};

export const notifyLoadFlow = () => {
    // eslint-disable-next-line no-unused-expressions
    window.top?.postMessage({type: LOAD_FLOW}, '*');
};

export const notifyPositionLeft = () => {
    // eslint-disable-next-line no-unused-expressions
    window.top?.postMessage({type: POSITION_LEFT}, '*');
};

